import { render, staticRenderFns } from "./Feats.vue?vue&type=template&id=12bb3651&"
import script from "./Feats.vue?vue&type=script&lang=js&"
export * from "./Feats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports